import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UserActions from '@Actions/userActions';
import Success from '@Images/admin/success.png';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';

/**
 *
 */
function BusySuccess({ history, getUserProfile }) {
  return (
    <div className="busy-success__wrapper">

      <div className="busy-success-action-wrapper__align">

        <img
          src={Success}
          alt="success "
          width="70px"
          height="70px"
          style={{
            marginBottom: '12px',
            marginTop: '10px',
          }}
        />

        <p className="busy-success-heading">Your Busy account is now Connected!</p>
        <p className="busy-success-subheading">Your transactions on Procuzy are now in Sync with your Busy account.</p>

        <div style={{ marginTop: '40px' }}>

          <H3Button
            text="Back to Integrations"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => {
              getUserProfile(() => {
                history.push('/admin/integration/');
              });
            }}
            customClass="busy__back-submit"
          />

        </div>

      </div>
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = (dispatch) => ({
  getUserProfile: (callback) => dispatch(UserActions.getUserProfile(callback)),

});
BusySuccess.propTypes = {
  history: PropTypes.any,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusySuccess));
